import React, { useCallback, useEffect } from "react";
import debounce from "lodash/debounce";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import config from "../../../../config";
import { ClientSearchName, ClientSuggetionListApi, CloseClientSearchList, OpenClientSearchList, SearchBox } from "store/slices/headerSlice";

import InfiniteScroll from "react-infinite-scroll-component";
import "component/PaginationLoader";
import ClientSuggetionListView from "./List/ClientSuggetionListView";
import BeatLoader from "react-spinners/BeatLoader";

const SearchSection = () => {
  // const auth = useSelector((state) => state.auth);
  // const currentUser = auth.user;
  // const role_id = currentUser && currentUser.role_id;
  // const is_owner = currentUser && currentUser.is_owner;
  // const access = useSelector((state) => state.salonmodule.isAccess);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isSearchbox = useSelector((state) => state.header.isSearchBox);
  //client search
  const isSearchList = useSelector((state) => state.header.isSearchList);
  const isSearchName = useSelector((state) => state.header.isSearchName);
  const isSuggetionListView = useSelector((state) => state.header.isSuggetionListView);
  const SuggetionApiStatus = useSelector((state) => state.header.isApiStatus);
  const clientListError = useSelector((state) => state.header.clientListError);

  useEffect(() => {
    dispatch(SearchBox(""));
  }, []);

  const fetchDataSuggetionList = () => {
    dispatch(ClientSuggetionListApi({ next_page_url: isSuggetionListView.next_page_url, q: isSearchName }));
  };

  const handleClickSearch = (e) => {
    let q = e.currentTarget.value;
    if (q && q.length > 0) {
      dispatch(OpenClientSearchList());
      dispatch(ClientSuggetionListApi({ q: q }));
    }
  };

  const debouncedClientSearch = useCallback(
    debounce((q) => {
      dispatch(OpenClientSearchList());
      dispatch(ClientSuggetionListApi({ q: q }));
    }, 500),
    [dispatch]
  );

  useEffect(() => {
    return () => {
      debouncedClientSearch.cancel();
    };
  }, [debouncedClientSearch]);

  const handleSearchChange = (e) => {
    let q = e.target.value;
    dispatch(ClientSearchName(q));
    if (q && q.length > 0) {
      dispatch(OpenClientSearchList());
      debouncedClientSearch(q);
    } else {
      debouncedClientSearch.cancel();
      dispatch(CloseClientSearchList());
    }
  };
  const handleCloseSearch = () => {
    debouncedClientSearch.cancel();
    dispatch(ClientSearchName(""));
    dispatch(CloseClientSearchList());
    dispatch(SearchBox(""));
  };
  const handleOnBlur = () => {
    // setTimeout(() => {
    //   dispatch(CloseClientSearchList());
    // }, 200);
  };
  return (
    <>
      <div className="search">
        {(!isSearchbox || isSearchbox == undefined || isSearchbox == "") && (
          <a className="search-icon" aria-label="Search" onClick={() => dispatch(SearchBox("open"))}>
            <img src={config.imagepath + "search.png"} alt="" />
          </a>
        )}
        {isSearchbox && (
          <div className={"search-wrapper " + isSearchbox}>
            <form>
              <div className="searchbox">
                <i className="fa fa-search"></i>
                <input type="text" className="form-control search-input" placeholder={t("Search Clients")} value={isSearchName} onChange={handleSearchChange} onClick={handleClickSearch} onBlur={handleOnBlur} />
                <a className="close cursor-pointer" aria-label="Close search" style={{ display: isSearchName ? "block" : "block" }} onClick={handleCloseSearch}>
                  <i className="fal fa-times"></i>
                </a>
              </div>
              <div className={"search-result dropdown-box " + isSearchList}>
                <InfiniteScroll className="" dataLength={isSuggetionListView && isSuggetionListView.data && isSuggetionListView.data.length ? isSuggetionListView.data.length : "0"} next={fetchDataSuggetionList} scrollableTarget="search-content" hasMore={isSuggetionListView.next_page_url ? true : false}>
                  {clientListError ? (
                    <p className="p-3 mb-0 text-danger" role="alert">
                      {clientListError.message}
                    </p>
                  ) : SuggetionApiStatus && SuggetionApiStatus.ClientSuggetionListApi === "loading" ? (
                    <BeatLoader color="#8c1c4d" className="text-center" />
                  ) : (
                    <ul className="p-0 m-0 list-unstyled">
                      <ClientSuggetionListView view={isSuggetionListView} page="header" />
                    </ul>
                  )}
                </InfiniteScroll>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchSection;
